<template>
  <div :class="'glassitem-stage' + activeClass" :key="curview">
    <div class="glassitem-stage-item">
      <div class="glass-item-inner">
        <div class="glass-item-image-holder">
          <Transition name="fade-fast">
            <ZoomImg v-if="currentColor.color_nr === col.color_nr" :src="getImage()"
                     zoom-type="drag" :zoom-scale="2"/>
          </Transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../config.js'
import {getImageName} from '@/composable/eonUtils'
import {computed} from 'vue'
import {ZoomImg} from "vue3-zoomer";

export default {
  name: "GlassItemStage",
  itemView: "",
  props: {
    Glassitem: Object,
    itemView: String,
    color: Object,
    active: Boolean,
    currentColor: Object,
    translate: Function,
  },
  setup(props) {
    const glass = computed(() => {
      return props.Glassitem
    })
    const curview = computed(() => {
      return props.itemView
    })
    const col = computed(() => {
      return props.color
    })
    const activeClass = computed(() => {
      const elClass = props.active ? ' active' : ' '
      return elClass
    })
    return {
      glass,
      col,
      curview,
      getImageName,
      activeClass
    }
  },
  methods: {

    getImage: function () {
      // Ein Front- oder Mood-Bild nur zeigen wenn es in der aktuellen Farbe auch existiert
      const view = (this.curview === "FRNT" && !this.col.hasFront) || (this.curview === "MOOD" && !this.col.hasMood) ? "" : this.curview
      return config.glassesBaseUrl + this.getImageName(this.glass, this.col, "pdp", view)

    }
  },
  components: {
    ZoomImg
  }
};
</script>


